import WalletInput from "./wallet-input";

import { useWallet, WalletType } from "@/providers/wallet";
import CopyButton from "../copy/copy-button";
import ActiveWalletBtn from "./active-wallet-btn";
import DeleteWalletButton from "./delete-wallet-button";
import KeyShowButton from "./key-show-button";
import DollarSignBtn from "./dollar-sign-btn";
import { Modal } from "@/ui/modals";
import { useState } from "react";
import { Button } from "@/ui/button";

const SolanaWalletControls = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [walletToDelete, setWalletToDelete] = useState<string | null>(null);

  const { solanaAddresses, currentWallet, setWallet, onWalletDelete } =
    useWallet();

  return (
    <div className="flex flex-col gap-[0.3125rem]">
      {solanaAddresses.map((solWallet, index) => (
        <div
          key={solWallet.address + index}
          className="flex flex-row items-center gap-[0.3125rem]"
        >
          <div className="text-xs text-white w-[7rem]">
            Wallet {currentWallet.address === solWallet.address && `(Active)`}:
          </div>
          <WalletInput
            key={solWallet.address}
            address={solWallet.address}
            walletType={WalletType.SOL}
          />
          <ActiveWalletBtn
            onClick={() => setWallet(solWallet)}
            active={currentWallet.address === solWallet.address}
          />
          <CopyButton
            value={solWallet.address}
            className="h-[1.375rem] w-[1.375rem]"
            iconClassName="w-[0.65rem] h-[0.65rem]"
          />
          <KeyShowButton onClick={() => {}} />
          <DollarSignBtn onClick={() => {}} />
          <DeleteWalletButton
            onClick={() => {
              setIsOpen(true);
              setWalletToDelete(solWallet.address);
            }}
          />
        </div>
      ))}
      <Modal
        opened={isOpen}
        onClose={() => {
          // Logic to close the modal
          // setIsOpen(false);
          // setDeleteMode(null);
        }}
        className="w-[28.125rem] h-[8rem]  bg-section-gradient"
        size="28rem"
      >
        <Modal.Title
          title="Delete Wallet"
          className="text-xs font-semibold mt-[0.3125rem]"
        />

        <Modal.Footer>
          <div className="w-full h-[5rem] flex flex-col justify-around items-center">
            <div className="text-xs font-semibold text-center text-white">
              Are you sure you want to delete wallet: {walletToDelete}?
            </div>

            <div className="flex justify-center items-center gap-[0.3125rem]">
              <Button
                active={false}
                title="Yes"
                className="w-[9.375rem] font-semibold text-xs"
                onClick={() => {
                  if (walletToDelete) {
                    onWalletDelete(walletToDelete, WalletType.SOL);
                  }
                  setIsOpen(false);
                  setWalletToDelete(null);
                }}
              />
              <Button
                onClick={() => setIsOpen(false)}
                active={false}
                title="No"
                className="w-[9.375rem] font-semibold text-xs"
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SolanaWalletControls;
